<template>
	<div style="margin: 20px 0;">
		<el-row type="flex" justify="center">
			<el-col :span="16">
				<el-row
					style="width: 100%; text-align: left;"
				>思考题1：在可见光实验中，针对呼吸器状态分析分别采用低通和高通滤波器，二者在截止频率的选择上有什么不同？</el-row>
				<el-row>
					<el-input
						style="width: 100%; margin: 20px 0;"
						type="textarea"
						:rows="10"
						placeholder="请输入回答"
						v-model="summary1"
					/>
				</el-row>
			</el-col>
		</el-row>
		<el-row type="flex" justify="center">
			<el-col :span="16">
				<el-row
					style="width: 100%; text-align: left;"
				>思考题2：在红外光实验中，如果为了突出套管的温度场分布细节，采用何种滤波器更恰当？为什么？如果为了保留图像更多的信息，采用何种滤波器更恰当？为什么?</el-row>
				<el-row>
					<el-input
						style="width: 100%; margin: 20px 0;"
						type="textarea"
						:rows="10"
						placeholder="请输入回答"
						v-model="summary2"
					/>
				</el-row>
			</el-col>
		</el-row>
		<el-row type="flex" justify="center">
			<el-col :span="16">
				<el-row
					style="width: 100%; text-align: left;"
				>思考题3：在变电站设备运行状态分析中，除了采用实验中给定的方法，还有没有其他技术或方法？如果有，请详述，并对比优劣。</el-row>
				<el-row>
					<el-input
						style="width: 100%; margin: 20px 0;"
						type="textarea"
						:rows="10"
						placeholder="请输入回答"
						v-model="summary3"
					/>
				</el-row>
			</el-col>
		</el-row>
		<el-row type="flex" justify="center">
			<el-col :span="16">
				<el-row style="width: 100%; text-align: left;">思考题4：请详述连续傅里叶级数、连续连续傅里叶变换、离散傅里叶级数和离散傅里叶变换的区别。</el-row>
				<el-row>
					<el-input
						style="width: 100%; margin: 20px 0;"
						type="textarea"
						:rows="10"
						placeholder="请输入回答"
						v-model="summary4"
					/>
				</el-row>
			</el-col>
		</el-row>
		<el-row type="flex" justify="center">
			<el-col :span="16">
				<el-row style="width: 100%; text-align: left;">思考题5 ：实验过程中遇到何种问题，又是如何解决的？请给出本次实验的心得体会。</el-row>
				<el-row>
					<el-input
						style="width: 100%; margin: 20px 0;"
						type="textarea"
						:rows="10"
						placeholder="请输入回答"
						v-model="summary5"
					/>
				</el-row>
			</el-col>
		</el-row>

		<el-row>
			<el-button type="primary" @click="download">生成报告</el-button>
		</el-row>
	</div>
</template>
<script>
import { mapState } from "vuex"
import Docxtemplater from 'docxtemplater'
import { saveAs } from 'file-saver'
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils'
export default {
	data() {
		return {
			summary1: '',
			summary2: '',
			summary3: '',
			summary4: '',
			summary5: '',
		}
	},
	computed: {
		...mapState([
			"logined", "name", "nickname", "number",
			"score1",
			"score2",
			"score3",
			"score0", "steps1", "steps2", "steps3"
		]),
		score4() {
			return (this.summary1.length > 10) * 2 + (this.summary2.length > 10) * 2 + (this.summary3.length > 10) * 2 + (this.summary4.length > 10) * 2 + (this.summary5.length > 10) * 2
		},
		score() {
			return this.score1 + this.score2 + this.score3 + this.score4 + this.score0
		}
	},
	methods: {
		download() {
			this.$message("正在下载实验报告，请稍等")
			JSZipUtils.getBinaryContent('template.docx', (error, content) => {
				let zip = new JSZip(content)
				let doc = new Docxtemplater()
				doc.loadZip(zip)
				doc.setData({
					name: this.name,
					nickname: this.nickname,
					number: this.number,
					score0: this.score0,
					score: this.score,
					score1: this.score1,
					score2: this.score2,
					score3: this.score3,
					score4: this.score4,
					steps1: this.steps1,
					steps2: this.steps2,
					steps3: this.steps3,
					summary1: this.summary1,
					summary2: this.summary2,
					summary3: this.summary3,
					summary4: this.summary4,
					summary5: this.summary5
				})
				doc.render()
				let out = doc.getZip().generate({
					type: 'blob',
					mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
				})
				saveAs(out, 'report.docx')
			})
		}
	}
}	
</script>
<style>
</style>
